/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_OtherInputs */

const tr_geliver_substatus_other = /** @type {(inputs: Geliver_Substatus_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diğer`)
};

const en_geliver_substatus_other = /** @type {(inputs: Geliver_Substatus_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de_geliver_substatus_other = /** @type {(inputs: Geliver_Substatus_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

const ru_geliver_substatus_other = /** @type {(inputs: Geliver_Substatus_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другое`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Geliver_Substatus_OtherInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_other = /** @type {((inputs?: Geliver_Substatus_OtherInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_OtherInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_other(inputs)
	if (locale === "de") return de_geliver_substatus_other(inputs)
	if (locale === "ru") return ru_geliver_substatus_other(inputs)
	return tr_geliver_substatus_other(inputs)
});